import { Entity, EntityEdge, EntityMap } from '@ms/yammer-data-support';

import { Campaign } from '../campaigns/types';
import { Group } from '../groups/types';
import { Network, Thread, User } from '../types';

// eslint-disable-next-line no-restricted-syntax
export enum SearchResultType {
  All = 'All',
  Thread = 'Thread',
  Group = 'Group',
  User = 'User',
  File = 'File',
  Inbox = 'Inbox',
  Topic = 'Topic',
  NetworkQuestion = 'NetworkQuestion',
  Campaign = 'Campaign',
}

// eslint-disable-next-line no-restricted-syntax
export enum SearchboxSourceType {
  MsTeamsSearch = 0,
  Publisher = 1,
  MainSearch = 2,
  DiscoverTopics = 3,
  SerpSessionEnforcement = 4,
  PublisherMention = 5,
  PublisherAudiencePicker = 6,
  AutocompletePicker = 7,
  DiscoverMoreTopicsSearchBar = 8,
  SearchFilterGroup = 9,
  SearchFilterUsers = 10,
  SearchFilterUser = 11,
}

export interface SearchLocationParameters {
  readonly searchText: string;
  readonly resultType: SearchResultType;
  readonly groupScope?: Group['id'];
  readonly campaignId?: Campaign['id'];
  readonly startDate?: number;
  readonly endDate?: number;
  readonly networkId?: Network['id'];
  readonly participantUserIds?: User['id'][];
  readonly threadStarterSenderId?: User['id'];
  readonly postType?: string;
}

export interface SearchParameters extends SearchLocationParameters {
  readonly locale: string;
  readonly count?: number;
  readonly includeVerifiedReply?: boolean;
}

export interface SearchLoadMoreParameters extends SearchParameters {
  readonly afterCursor?: string;
}

export type SearchResultEdge = EntityEdge<Entity> & { readonly cursor: string };

export interface SearchResultsForType extends Entity {
  readonly id: string;
  readonly results: SearchResultEdge[];
  readonly hasNextPage: boolean;
  readonly endCursor?: string;
}

export interface NetworkQuestionSearchResult extends Entity {
  readonly id: string;
  readonly results: SearchResultEdge[];
  readonly hasNextPage: boolean;
  readonly endCursor?: string;
}

export interface NetworkQuestionPublisherSearchResult extends Entity {
  readonly id: string;
  readonly results: SearchResultEdge[];
}

export type Searches = EntityMap<SearchResultsForType>;

export class SearchResultThreadRenderError extends Error {
  public threadId: Thread['id'];

  constructor(error: Error, threadId: Thread['id']) {
    super();

    this.threadId = threadId;
    this.message = error.message;
    this.stack = error.stack;

    Object.setPrototypeOf(this, SearchResultThreadRenderError.prototype);
  }
}
